import { useEffect, useRef, useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { renderMarkdown } from "@/lib/render-markdown";

interface StreamingOutputProps {
  content: string;
  isStreaming: boolean;
}

export function StreamingOutput({ content, isStreaming }: StreamingOutputProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
    if (autoScroll && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [content, autoScroll]);

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    setAutoScroll(scrollHeight - scrollTop - clientHeight < 50);
  };

  if (!content && !isStreaming) return null;

  return (
    <div className="rounded-lg border bg-card">
      <div className="px-3 py-2 border-b flex items-center justify-between">
        <span className="text-xs font-medium text-muted-foreground">Output</span>
        {isStreaming && (
          <span className="text-[10px] text-info flex items-center gap-1">
            <span className="inline-block w-1.5 h-3 bg-info animate-pulse" />
            Streaming...
          </span>
        )}
      </div>
      <ScrollArea className="h-[400px]" ref={scrollRef} onScrollCapture={handleScroll}>
        <div className="p-4 prose-sm">
          {renderMarkdown(content)}
          {isStreaming && (
            <span className="inline-block w-1.5 h-4 bg-info animate-pulse ml-0.5" />
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
